import { render, staticRenderFns } from "./ProcessCreateComprehensiveDamageAssessor.vue?vue&type=template&id=28c83477"
import script from "./ProcessCreateComprehensiveDamageAssessor.vue?vue&type=script&lang=js"
export * from "./ProcessCreateComprehensiveDamageAssessor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports